$(document).ready(function () {
  $("#Program").focus(function () {
    cleartb();
  });
  $("#Program").click(function () {
    cleartb();
  });

  $(function () {
    $("#Program").keyup(function () {
      if (this.value.match(/[^a-zA-Z]/g)) {
        this.value = this.value.replace(/[^a-zA-Z]/g, "");
      }
    });
  });
});

function cleartb() {
  var dept = document.getElementById("Program");
  if (dept) {
    dept.value = "";
  }
}

// autocomplete Program
$(document).ready(function () {
  $("#Program").autocomplete({
    source: function (request, response) {
      var activeTermValue = $("#ActiveTerm").val();
      
      $.ajax({
        url: "/Api/Search/AutocompleteProgram",
        type: "Get",
        dataType: "json",
        data: { activeTerm: activeTermValue, search: request.term },
        success: function (data) {
          //debugger;
          response(
            $.map(data, function (item) {
              return {
                label: item.Title + " (" + item.Id + ")",
                value: item.Id,
              };
            })
          );
        },
        error: { error: "errrr" },
      });
    },
    minLength: 1,
    select: function (event, ui) {
      $(this).val(ui.item.value);
      $("#formdeptsrch").submit();
      return false;
    },
  });
});

function aPatchAutocomplete() {
  $.ui.autocomplete.prototype._renderItem = function (ul, item) {
    // background-color:#ffcc00;
    item.label = item.label.replace(
      new RegExp(
        "(?![^&;]+;)(?!<[^<>]*)(" +
          $.ui.autocomplete.escapeRegex(this.term) +
          ")(?![^<>]*>)(?![^&;]+;)",
        "gi"
      ),
      "<span style='font-weight:bold;color:#990000;'><strong>$1</strong></span>"
    );
    return $("<li></li>")
      .data("item.autocomplete", item)
      .append("<a>" + item.label + "</a>")
      .appendTo(ul);
  };
}

$(function () {
  aPatchAutocomplete();
});
